module.exports = __webpack_public_path__ + "img/img3.e1179c37.svg";